// extracted by mini-css-extract-plugin
export default {"userpic":"lsf-userpic","userpic__username":"lsf-userpic__username","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630380207
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  